import type { App } from 'vue'
import JtIconAdaptAuto from './JtIconAdaptAuto.vue'
import JtIconAdaptHeight from './JtIconAdaptHeight.vue'
import JtIconAdaptWidth from './JtIconAdaptWidth.vue'
import JtIconAddLocation from './JtIconAddLocation.vue'
import JtIconAim from './JtIconAim.vue'
import JtIconAlarmClock from './JtIconAlarmClock.vue'
import JtIconApple from './JtIconApple.vue'
import JtIconArrowDown from './JtIconArrowDown.vue'
import JtIconArrowDown2 from './JtIconArrowDown2.vue'
import JtIconArrowDownBold from './JtIconArrowDownBold.vue'
import JtIconArrowLeft from './JtIconArrowLeft.vue'
import JtIconArrowLeft2 from './JtIconArrowLeft2.vue'
import JtIconArrowLeftBold from './JtIconArrowLeftBold.vue'
import JtIconArrowRight from './JtIconArrowRight.vue'
import JtIconArrowRight2 from './JtIconArrowRight2.vue'
import JtIconArrowRightBold from './JtIconArrowRightBold.vue'
import JtIconArrowUp from './JtIconArrowUp.vue'
import JtIconArrowUp2 from './JtIconArrowUp2.vue'
import JtIconArrowUpBold from './JtIconArrowUpBold.vue'
import JtIconAvatar from './JtIconAvatar.vue'
import JtIconBack from './JtIconBack.vue'
import JtIconBack2 from './JtIconBack2.vue'
import JtIconBaseball from './JtIconBaseball.vue'
import JtIconBasketball from './JtIconBasketball.vue'
import JtIconBell from './JtIconBell.vue'
import JtIconBellFilled from './JtIconBellFilled.vue'
import JtIconBicycle from './JtIconBicycle.vue'
import JtIconBottom from './JtIconBottom.vue'
import JtIconBottomLeft from './JtIconBottomLeft.vue'
import JtIconBottomRight from './JtIconBottomRight.vue'
import JtIconBowl from './JtIconBowl.vue'
import JtIconBox from './JtIconBox.vue'
import JtIconBox2 from './JtIconBox2.vue'
import JtIconBriefcase from './JtIconBriefcase.vue'
import JtIconBrush from './JtIconBrush.vue'
import JtIconBrushFilled from './JtIconBrushFilled.vue'
import JtIconBurger from './JtIconBurger.vue'
import JtIconCalendar from './JtIconCalendar.vue'
import JtIconCamera from './JtIconCamera.vue'
import JtIconCameraFilled from './JtIconCameraFilled.vue'
import JtIconCaretBottom from './JtIconCaretBottom.vue'
import JtIconCaretLeft from './JtIconCaretLeft.vue'
import JtIconCaretRight from './JtIconCaretRight.vue'
import JtIconCaretTop from './JtIconCaretTop.vue'
import JtIconCellphone from './JtIconCellphone.vue'
import JtIconChart from './JtIconChart.vue'
import JtIconChartBar from './JtIconChartBar.vue'
import JtIconChartLine from './JtIconChartLine.vue'
import JtIconChartPie from './JtIconChartPie.vue'
import JtIconChatDotRound from './JtIconChatDotRound.vue'
import JtIconChatDotSquare from './JtIconChatDotSquare.vue'
import JtIconChatLineRound from './JtIconChatLineRound.vue'
import JtIconChatLineSquare from './JtIconChatLineSquare.vue'
import JtIconChatRound from './JtIconChatRound.vue'
import JtIconChatSquare from './JtIconChatSquare.vue'
import JtIconCheck from './JtIconCheck.vue'
import JtIconChecked from './JtIconChecked.vue'
import JtIconCherry from './JtIconCherry.vue'
import JtIconChicken from './JtIconChicken.vue'
import JtIconCircleCheck from './JtIconCircleCheck.vue'
import JtIconCircleCheckFilled from './JtIconCircleCheckFilled.vue'
import JtIconCircleClose from './JtIconCircleClose.vue'
import JtIconCircleCloseFilled from './JtIconCircleCloseFilled.vue'
import JtIconCirclePlus from './JtIconCirclePlus.vue'
import JtIconCirclePlusFilled from './JtIconCirclePlusFilled.vue'
import JtIconClock from './JtIconClock.vue'
import JtIconClose from './JtIconClose.vue'
import JtIconClose2 from './JtIconClose2.vue'
import JtIconCloseBold from './JtIconCloseBold.vue'
import JtIconCloud from './JtIconCloud.vue'
import JtIconCloudy from './JtIconCloudy.vue'
import JtIconCoffee from './JtIconCoffee.vue'
import JtIconCoffeeCup from './JtIconCoffeeCup.vue'
import JtIconCoin from './JtIconCoin.vue'
import JtIconColdDrink from './JtIconColdDrink.vue'
import JtIconCollection from './JtIconCollection.vue'
import JtIconCollectionTag from './JtIconCollectionTag.vue'
import JtIconComInfo from './JtIconComInfo.vue'
import JtIconComment from './JtIconComment.vue'
import JtIconCompass from './JtIconCompass.vue'
import JtIconComplete from './JtIconComplete.vue'
import JtIconConnection from './JtIconConnection.vue'
import JtIconCoordinate from './JtIconCoordinate.vue'
import JtIconCopy from './JtIconCopy.vue'
import JtIconCopyDocument from './JtIconCopyDocument.vue'
import JtIconCpu from './JtIconCpu.vue'
import JtIconCreditCard from './JtIconCreditCard.vue'
import JtIconCrop from './JtIconCrop.vue'
import JtIconDarrowLeft from './JtIconDArrowLeft.vue'
import JtIconDarrowRight from './JtIconDArrowRight.vue'
import JtIconDataAnalysis from './JtIconDataAnalysis.vue'
import JtIconDataBoard from './JtIconDataBoard.vue'
import JtIconDataLine from './JtIconDataLine.vue'
import JtIconDcaret from './JtIconDCaret.vue'
import JtIconDelete from './JtIconDelete.vue'
import JtIconDelete2 from './JtIconDelete2.vue'
import JtIconDeleteFilled from './JtIconDeleteFilled.vue'
import JtIconDeleteLocation from './JtIconDeleteLocation.vue'
import JtIconDessert from './JtIconDessert.vue'
import JtIconDiscount from './JtIconDiscount.vue'
import JtIconDish from './JtIconDish.vue'
import JtIconDishDot from './JtIconDishDot.vue'
import JtIconDocument from './JtIconDocument.vue'
import JtIconDocument2 from './JtIconDocument2.vue'
import JtIconDocumentAdd from './JtIconDocumentAdd.vue'
import JtIconDocumentChecked from './JtIconDocumentChecked.vue'
import JtIconDocumentCopy from './JtIconDocumentCopy.vue'
import JtIconDocumentDelete from './JtIconDocumentDelete.vue'
import JtIconDocumentRemove from './JtIconDocumentRemove.vue'
import JtIconDownload from './JtIconDownload.vue'
import JtIconDrag from './JtIconDrag.vue'
import JtIconDrizzling from './JtIconDrizzling.vue'
import JtIconEdit from './JtIconEdit.vue'
import JtIconEdit2 from './JtIconEdit2.vue'
import JtIconEditorCanvas from './JtIconEditorCanvas.vue'
import JtIconEditPen from './JtIconEditPen.vue'
import JtIconExpand from './JtIconExpand.vue'
import JtIconFailed from './JtIconFailed.vue'
import JtIconFavorite from './JtIconFavorite.vue'
import JtIconFemale from './JtIconFemale.vue'
import JtIconFiles from './JtIconFiles.vue'
import JtIconFilm from './JtIconFilm.vue'
import JtIconFilter from './JtIconFilter.vue'
import JtIconFilter2 from './JtIconFilter2.vue'
import JtIconFinished from './JtIconFinished.vue'
import JtIconFirstAidKit from './JtIconFirstAidKit.vue'
import JtIconFlag from './JtIconFlag.vue'
import JtIconFlipH from './JtIconFlipH.vue'
import JtIconFlipV from './JtIconFlipV.vue'
import JtIconFold from './JtIconFold.vue'
import JtIconFolder from './JtIconFolder.vue'
import JtIconFolderAdd from './JtIconFolderAdd.vue'
import JtIconFolderChecked from './JtIconFolderChecked.vue'
import JtIconFolderDelete from './JtIconFolderDelete.vue'
import JtIconFolderOpened from './JtIconFolderOpened.vue'
import JtIconFolderRemove from './JtIconFolderRemove.vue'
import JtIconFood from './JtIconFood.vue'
import JtIconFootball from './JtIconFootball.vue'
import JtIconForkSpoon from './JtIconForkSpoon.vue'
import JtIconFries from './JtIconFries.vue'
import JtIconFullscreen from './JtIconFullscreen.vue'
import JtIconFullScreen2 from './JtIconFullScreen2.vue'
import JtIconFullscreenExit from './JtIconFullscreenExit.vue'
import JtIconGoblet from './JtIconGoblet.vue'
import JtIconGobletFull from './JtIconGobletFull.vue'
import JtIconGobletSquare from './JtIconGobletSquare.vue'
import JtIconGobletSquareFull from './JtIconGobletSquareFull.vue'
import JtIconGoods from './JtIconGoods.vue'
import JtIconGoodsFilled from './JtIconGoodsFilled.vue'
import JtIconGrape from './JtIconGrape.vue'
import JtIconGrid from './JtIconGrid.vue'
import JtIconGuide from './JtIconGuide.vue'
import JtIconHeadset from './JtIconHeadset.vue'
import JtIconHelp from './JtIconHelp.vue'
import JtIconHelp2 from './JtIconHelp2.vue'
import JtIconHelpFilled from './JtIconHelpFilled.vue'
import JtIconHide from './JtIconHide.vue'
import JtIconHide2 from './JtIconHide2.vue'
import JtIconHistogram from './JtIconHistogram.vue'
import JtIconHomeFilled from './JtIconHomeFilled.vue'
import JtIconHotWater from './JtIconHotWater.vue'
import JtIconHouse from './JtIconHouse.vue'
import JtIconIceCream from './JtIconIceCream.vue'
import JtIconIceCreamRound from './JtIconIceCreamRound.vue'
import JtIconIceCreamSquare from './JtIconIceCreamSquare.vue'
import JtIconIceDrink from './JtIconIceDrink.vue'
import JtIconIceTea from './JtIconIceTea.vue'
import JtIconImg from './JtIconImg.vue'
import JtIconInfoFilled from './JtIconInfoFilled.vue'
import JtIconInteract from './JtIconInteract.vue'
import JtIconInternational from './JtIconInternational.vue'
import JtIconIphone from './JtIconIphone.vue'
import JtIconKey from './JtIconKey.vue'
import JtIconKey2 from './JtIconKey2.vue'
import JtIconKeyboard from './JtIconKeyboard.vue'
import JtIconKnifeFork from './JtIconKnifeFork.vue'
import JtIconLayer from './JtIconLayer.vue'
import JtIconLayoutColumn from './JtIconLayoutColumn.vue'
import JtIconLayoutRow from './JtIconLayoutRow.vue'
import JtIconLightning from './JtIconLightning.vue'
import JtIconLineHide from './JtIconLineHide.vue'
import JtIconLineShow from './JtIconLineShow.vue'
import JtIconLink from './JtIconLink.vue'
import JtIconLink2 from './JtIconLink2.vue'
import JtIconList from './JtIconList.vue'
import JtIconLoading from './JtIconLoading.vue'
import JtIconLocation from './JtIconLocation.vue'
import JtIconLocationFilled from './JtIconLocationFilled.vue'
import JtIconLocationInformation from './JtIconLocationInformation.vue'
import JtIconLock from './JtIconLock.vue'
import JtIconLock2 from './JtIconLock2.vue'
import JtIconLogout from './JtIconLogout.vue'
import JtIconLollipop from './JtIconLollipop.vue'
import JtIconMagic from './JtIconMagic.vue'
import JtIconMagicStick from './JtIconMagicStick.vue'
import JtIconMagnet from './JtIconMagnet.vue'
import JtIconMale from './JtIconMale.vue'
import JtIconManagement from './JtIconManagement.vue'
import JtIconMap from './JtIconMap.vue'
import JtIconMapLocation from './JtIconMapLocation.vue'
import JtIconMaterial from './JtIconMaterial.vue'
import JtIconMedal from './JtIconMedal.vue'
import JtIconMedia from './JtIconMedia.vue'
import JtIconMenu from './JtIconMenu.vue'
import JtIconMessage from './JtIconMessage.vue'
import JtIconMessageBox from './JtIconMessageBox.vue'
import JtIconMic from './JtIconMic.vue'
import JtIconMicrophone from './JtIconMicrophone.vue'
import JtIconMilkTea from './JtIconMilkTea.vue'
import JtIconMinus from './JtIconMinus.vue'
import JtIconMobile from './JtIconMobile.vue'
import JtIconMoney from './JtIconMoney.vue'
import JtIconMonitor from './JtIconMonitor.vue'
import JtIconMoon from './JtIconMoon.vue'
import JtIconMoonNight from './JtIconMoonNight.vue'
import JtIconMore from './JtIconMore.vue'
import JtIconMoreFilled from './JtIconMoreFilled.vue'
import JtIconMostlyCloudy from './JtIconMostlyCloudy.vue'
import JtIconMouse from './JtIconMouse.vue'
import JtIconMove from './JtIconMove.vue'
import JtIconMoveBottom from './JtIconMoveBottom.vue'
import JtIconMoveDown from './JtIconMoveDown.vue'
import JtIconMoveTop from './JtIconMoveTop.vue'
import JtIconMoveUp from './JtIconMoveUp.vue'
import JtIconMug from './JtIconMug.vue'
import JtIconMute from './JtIconMute.vue'
import JtIconMuteNotification from './JtIconMuteNotification.vue'
import JtIconMyCom from './JtIconMyCom.vue'
import JtIconMyData from './JtIconMyData.vue'
import JtIconNodal from './JtIconNodal.vue'
import JtIconNoSmoking from './JtIconNoSmoking.vue'
import JtIconNotebook from './JtIconNotebook.vue'
import JtIconNotification from './JtIconNotification.vue'
import JtIconOdometer from './JtIconOdometer.vue'
import JtIconOfficeBuilding from './JtIconOfficeBuilding.vue'
import JtIconOpen from './JtIconOpen.vue'
import JtIconOperation from './JtIconOperation.vue'
import JtIconOpportunity from './JtIconOpportunity.vue'
import JtIconOrange from './JtIconOrange.vue'
import JtIconOther from './JtIconOther.vue'
import JtIconPaperclip from './JtIconPaperclip.vue'
import JtIconPartlyCloudy from './JtIconPartlyCloudy.vue'
import JtIconPear from './JtIconPear.vue'
import JtIconPhone from './JtIconPhone.vue'
import JtIconPhoneFilled from './JtIconPhoneFilled.vue'
import JtIconPicture from './JtIconPicture.vue'
import JtIconPictureFilled from './JtIconPictureFilled.vue'
import JtIconPictureRounded from './JtIconPictureRounded.vue'
import JtIconPieChart from './JtIconPieChart.vue'
import JtIconPlace from './JtIconPlace.vue'
import JtIconPlatform from './JtIconPlatform.vue'
import JtIconPlus from './JtIconPlus.vue'
import JtIconPlus2 from './JtIconPlus2.vue'
import JtIconPointer from './JtIconPointer.vue'
import JtIconPosition from './JtIconPosition.vue'
import JtIconPostcard from './JtIconPostcard.vue'
import JtIconPouring from './JtIconPouring.vue'
import JtIconPresent from './JtIconPresent.vue'
import JtIconPreview from './JtIconPreview.vue'
import JtIconPriceTag from './JtIconPriceTag.vue'
import JtIconPrinter from './JtIconPrinter.vue'
import JtIconPromotion from './JtIconPromotion.vue'
import JtIconQuestionFilled from './JtIconQuestionFilled.vue'
import JtIconRank from './JtIconRank.vue'
import JtIconReading from './JtIconReading.vue'
import JtIconReadingLamp from './JtIconReadingLamp.vue'
import JtIconRedo from './JtIconRedo.vue'
import JtIconRefresh from './JtIconRefresh.vue'
import JtIconRefresh2 from './JtIconRefresh2.vue'
import JtIconRefreshLeft from './JtIconRefreshLeft.vue'
import JtIconRefreshRight from './JtIconRefreshRight.vue'
import JtIconRefrigerator from './JtIconRefrigerator.vue'
import JtIconRelation from './JtIconRelation.vue'
import JtIconRelease from './JtIconRelease.vue'
import JtIconRemove from './JtIconRemove.vue'
import JtIconRemoveFilled from './JtIconRemoveFilled.vue'
import JtIconRight from './JtIconRight.vue'
import JtIconRpanel from './JtIconRpanel.vue'
import JtIconScaleToOriginal from './JtIconScaleToOriginal.vue'
import JtIconSchool from './JtIconSchool.vue'
import JtIconScissor from './JtIconScissor.vue'
import JtIconSearch from './JtIconSearch.vue'
import JtIconSearch2 from './JtIconSearch2.vue'
import JtIconSelect from './JtIconSelect.vue'
import JtIconSelectArrow from './JtIconSelectArrow.vue'
import JtIconSell from './JtIconSell.vue'
import JtIconSemiSelect from './JtIconSemiSelect.vue'
import JtIconService from './JtIconService.vue'
import JtIconSetting from './JtIconSetting.vue'
import JtIconSetting2 from './JtIconSetting2.vue'
import JtIconSetUp from './JtIconSetUp.vue'
import JtIconShapeArrow from './JtIconShapeArrow.vue'
import JtIconShapeAuto from './JtIconShapeAuto.vue'
import JtIconShapeCircle from './JtIconShapeCircle.vue'
import JtIconShapeDiamond from './JtIconShapeDiamond.vue'
import JtIconShapeEmptyHeart from './JtIconShapeEmptyHeart.vue'
import JtIconShapeHeart from './JtIconShapeHeart.vue'
import JtIconShapeHexagon from './JtIconShapeHexagon.vue'
import JtIconShapeRect from './JtIconShapeRect.vue'
import JtIconShapeRoundRect from './JtIconShapeRoundRect.vue'
import JtIconShapeRoundSquare from './JtIconShapeRoundSquare.vue'
import JtIconShapeSquare from './JtIconShapeSquare.vue'
import JtIconShapeTriangle from './JtIconShapeTriangle.vue'
import JtIconShare from './JtIconShare.vue'
import JtIconShip from './JtIconShip.vue'
import JtIconShop from './JtIconShop.vue'
import JtIconShoppingBag from './JtIconShoppingBag.vue'
import JtIconShoppingCart from './JtIconShoppingCart.vue'
import JtIconShoppingCartFull from './JtIconShoppingCartFull.vue'
import JtIconShow from './JtIconShow.vue'
import JtIconSmoking from './JtIconSmoking.vue'
import JtIconSnapshot from './JtIconSnapshot.vue'
import JtIconSoccer from './JtIconSoccer.vue'
import JtIconSoldOut from './JtIconSoldOut.vue'
import JtIconSort from './JtIconSort.vue'
import JtIconSortDown from './JtIconSortDown.vue'
import JtIconSortUp from './JtIconSortUp.vue'
import JtIconStamp from './JtIconStamp.vue'
import JtIconStar from './JtIconStar.vue'
import JtIconStarFilled from './JtIconStarFilled.vue'
import JtIconStop from './JtIconStop.vue'
import JtIconStopwatch from './JtIconStopwatch.vue'
import JtIconSuccessFilled from './JtIconSuccessFilled.vue'
import JtIconSugar from './JtIconSugar.vue'
import JtIconSuitcase from './JtIconSuitcase.vue'
import JtIconSunny from './JtIconSunny.vue'
import JtIconSunrise from './JtIconSunrise.vue'
import JtIconSunset from './JtIconSunset.vue'
import JtIconSwitch from './JtIconSwitch.vue'
import JtIconSwitchButton from './JtIconSwitchButton.vue'
import JtIconTable from './JtIconTable.vue'
import JtIconTakeawayBox from './JtIconTakeawayBox.vue'
import JtIconTicket from './JtIconTicket.vue'
import JtIconTickets from './JtIconTickets.vue'
import JtIconTimer from './JtIconTimer.vue'
import JtIconTitle from './JtIconTitle.vue'
import JtIconToiletPaper from './JtIconToiletPaper.vue'
import JtIconToolbox from './JtIconToolbox.vue'
import JtIconTools from './JtIconTools.vue'
import JtIconTop from './JtIconTop.vue'
import JtIconTopLeft from './JtIconTopLeft.vue'
import JtIconTopRight from './JtIconTopRight.vue'
import JtIconTrendCharts from './JtIconTrendCharts.vue'
import JtIconTrophy from './JtIconTrophy.vue'
import JtIconTurnOff from './JtIconTurnOff.vue'
import JtIconTutorial from './JtIconTutorial.vue'
import JtIconUmbrella from './JtIconUmbrella.vue'
import JtIconUndo from './JtIconUndo.vue'
import JtIconUnlock from './JtIconUnlock.vue'
import JtIconUnlock2 from './JtIconUnlock2.vue'
import JtIconUpload from './JtIconUpload.vue'
import JtIconUploadFilled from './JtIconUploadFilled.vue'
import JtIconUser from './JtIconUser.vue'
import JtIconUser2 from './JtIconUser2.vue'
import JtIconUserFilled from './JtIconUserFilled.vue'
import JtIconVan from './JtIconVan.vue'
import JtIconVideoCamera from './JtIconVideoCamera.vue'
import JtIconVideoCameraFilled from './JtIconVideoCameraFilled.vue'
import JtIconVideoPause from './JtIconVideoPause.vue'
import JtIconVideoPlay from './JtIconVideoPlay.vue'
import JtIconView from './JtIconView.vue'
import JtIconViewGrid from './JtIconViewGrid.vue'
import JtIconViewList from './JtIconViewList.vue'
import JtIconWallet from './JtIconWallet.vue'
import JtIconWalletFilled from './JtIconWalletFilled.vue'
import JtIconWarning from './JtIconWarning.vue'
import JtIconWarning2 from './JtIconWarning2.vue'
import JtIconWarningFilled from './JtIconWarningFilled.vue'
import JtIconWatch from './JtIconWatch.vue'
import JtIconWatermelon from './JtIconWatermelon.vue'
import JtIconWindPower from './JtIconWindPower.vue'
import JtIconWorkspace from './JtIconWorkspace.vue'
import JtIconZoomIn from './JtIconZoomIn.vue'
import JtIconZoomOut from './JtIconZoomOut.vue'

function install(app: App) {
  app.component(JtIconAdaptAuto.name!, JtIconAdaptAuto)
  app.component(JtIconAdaptHeight.name!, JtIconAdaptHeight)
  app.component(JtIconAdaptWidth.name!, JtIconAdaptWidth)
  app.component(JtIconAddLocation.name!, JtIconAddLocation)
  app.component(JtIconAim.name!, JtIconAim)
  app.component(JtIconAlarmClock.name!, JtIconAlarmClock)
  app.component(JtIconApple.name!, JtIconApple)
  app.component(JtIconArrowDown.name!, JtIconArrowDown)
  app.component(JtIconArrowDown2.name!, JtIconArrowDown2)
  app.component(JtIconArrowDownBold.name!, JtIconArrowDownBold)
  app.component(JtIconArrowLeft.name!, JtIconArrowLeft)
  app.component(JtIconArrowLeft2.name!, JtIconArrowLeft2)
  app.component(JtIconArrowLeftBold.name!, JtIconArrowLeftBold)
  app.component(JtIconArrowRight.name!, JtIconArrowRight)
  app.component(JtIconArrowRight2.name!, JtIconArrowRight2)
  app.component(JtIconArrowRightBold.name!, JtIconArrowRightBold)
  app.component(JtIconArrowUp.name!, JtIconArrowUp)
  app.component(JtIconArrowUp2.name!, JtIconArrowUp2)
  app.component(JtIconArrowUpBold.name!, JtIconArrowUpBold)
  app.component(JtIconAvatar.name!, JtIconAvatar)
  app.component(JtIconBack.name!, JtIconBack)
  app.component(JtIconBack2.name!, JtIconBack2)
  app.component(JtIconBaseball.name!, JtIconBaseball)
  app.component(JtIconBasketball.name!, JtIconBasketball)
  app.component(JtIconBell.name!, JtIconBell)
  app.component(JtIconBellFilled.name!, JtIconBellFilled)
  app.component(JtIconBicycle.name!, JtIconBicycle)
  app.component(JtIconBottom.name!, JtIconBottom)
  app.component(JtIconBottomLeft.name!, JtIconBottomLeft)
  app.component(JtIconBottomRight.name!, JtIconBottomRight)
  app.component(JtIconBowl.name!, JtIconBowl)
  app.component(JtIconBox.name!, JtIconBox)
  app.component(JtIconBox2.name!, JtIconBox2)
  app.component(JtIconBriefcase.name!, JtIconBriefcase)
  app.component(JtIconBrush.name!, JtIconBrush)
  app.component(JtIconBrushFilled.name!, JtIconBrushFilled)
  app.component(JtIconBurger.name!, JtIconBurger)
  app.component(JtIconCalendar.name!, JtIconCalendar)
  app.component(JtIconCamera.name!, JtIconCamera)
  app.component(JtIconCameraFilled.name!, JtIconCameraFilled)
  app.component(JtIconCaretBottom.name!, JtIconCaretBottom)
  app.component(JtIconCaretLeft.name!, JtIconCaretLeft)
  app.component(JtIconCaretRight.name!, JtIconCaretRight)
  app.component(JtIconCaretTop.name!, JtIconCaretTop)
  app.component(JtIconCellphone.name!, JtIconCellphone)
  app.component(JtIconChart.name!, JtIconChart)
  app.component(JtIconChartBar.name!, JtIconChartBar)
  app.component(JtIconChartLine.name!, JtIconChartLine)
  app.component(JtIconChartPie.name!, JtIconChartPie)
  app.component(JtIconChatDotRound.name!, JtIconChatDotRound)
  app.component(JtIconChatDotSquare.name!, JtIconChatDotSquare)
  app.component(JtIconChatLineRound.name!, JtIconChatLineRound)
  app.component(JtIconChatLineSquare.name!, JtIconChatLineSquare)
  app.component(JtIconChatRound.name!, JtIconChatRound)
  app.component(JtIconChatSquare.name!, JtIconChatSquare)
  app.component(JtIconCheck.name!, JtIconCheck)
  app.component(JtIconChecked.name!, JtIconChecked)
  app.component(JtIconCherry.name!, JtIconCherry)
  app.component(JtIconChicken.name!, JtIconChicken)
  app.component(JtIconCircleCheck.name!, JtIconCircleCheck)
  app.component(JtIconCircleCheckFilled.name!, JtIconCircleCheckFilled)
  app.component(JtIconCircleClose.name!, JtIconCircleClose)
  app.component(JtIconCircleCloseFilled.name!, JtIconCircleCloseFilled)
  app.component(JtIconCirclePlus.name!, JtIconCirclePlus)
  app.component(JtIconCirclePlusFilled.name!, JtIconCirclePlusFilled)
  app.component(JtIconClock.name!, JtIconClock)
  app.component(JtIconClose.name!, JtIconClose)
  app.component(JtIconClose2.name!, JtIconClose2)
  app.component(JtIconCloseBold.name!, JtIconCloseBold)
  app.component(JtIconCloud.name!, JtIconCloud)
  app.component(JtIconCloudy.name!, JtIconCloudy)
  app.component(JtIconCoffee.name!, JtIconCoffee)
  app.component(JtIconCoffeeCup.name!, JtIconCoffeeCup)
  app.component(JtIconCoin.name!, JtIconCoin)
  app.component(JtIconColdDrink.name!, JtIconColdDrink)
  app.component(JtIconCollection.name!, JtIconCollection)
  app.component(JtIconCollectionTag.name!, JtIconCollectionTag)
  app.component(JtIconComInfo.name!, JtIconComInfo)
  app.component(JtIconComment.name!, JtIconComment)
  app.component(JtIconCompass.name!, JtIconCompass)
  app.component(JtIconComplete.name!, JtIconComplete)
  app.component(JtIconConnection.name!, JtIconConnection)
  app.component(JtIconCoordinate.name!, JtIconCoordinate)
  app.component(JtIconCopy.name!, JtIconCopy)
  app.component(JtIconCopyDocument.name!, JtIconCopyDocument)
  app.component(JtIconCpu.name!, JtIconCpu)
  app.component(JtIconCreditCard.name!, JtIconCreditCard)
  app.component(JtIconCrop.name!, JtIconCrop)
  app.component(JtIconDarrowLeft.name!, JtIconDarrowLeft)
  app.component(JtIconDarrowRight.name!, JtIconDarrowRight)
  app.component(JtIconDataAnalysis.name!, JtIconDataAnalysis)
  app.component(JtIconDataBoard.name!, JtIconDataBoard)
  app.component(JtIconDataLine.name!, JtIconDataLine)
  app.component(JtIconDcaret.name!, JtIconDcaret)
  app.component(JtIconDelete.name!, JtIconDelete)
  app.component(JtIconDelete2.name!, JtIconDelete2)
  app.component(JtIconDeleteFilled.name!, JtIconDeleteFilled)
  app.component(JtIconDeleteLocation.name!, JtIconDeleteLocation)
  app.component(JtIconDessert.name!, JtIconDessert)
  app.component(JtIconDiscount.name!, JtIconDiscount)
  app.component(JtIconDish.name!, JtIconDish)
  app.component(JtIconDishDot.name!, JtIconDishDot)
  app.component(JtIconDocument.name!, JtIconDocument)
  app.component(JtIconDocument2.name!, JtIconDocument2)
  app.component(JtIconDocumentAdd.name!, JtIconDocumentAdd)
  app.component(JtIconDocumentChecked.name!, JtIconDocumentChecked)
  app.component(JtIconDocumentCopy.name!, JtIconDocumentCopy)
  app.component(JtIconDocumentDelete.name!, JtIconDocumentDelete)
  app.component(JtIconDocumentRemove.name!, JtIconDocumentRemove)
  app.component(JtIconDownload.name!, JtIconDownload)
  app.component(JtIconDrag.name!, JtIconDrag)
  app.component(JtIconDrizzling.name!, JtIconDrizzling)
  app.component(JtIconEdit.name!, JtIconEdit)
  app.component(JtIconEdit2.name!, JtIconEdit2)
  app.component(JtIconEditorCanvas.name!, JtIconEditorCanvas)
  app.component(JtIconEditPen.name!, JtIconEditPen)
  app.component(JtIconExpand.name!, JtIconExpand)
  app.component(JtIconFailed.name!, JtIconFailed)
  app.component(JtIconFavorite.name!, JtIconFavorite)
  app.component(JtIconFemale.name!, JtIconFemale)
  app.component(JtIconFiles.name!, JtIconFiles)
  app.component(JtIconFilm.name!, JtIconFilm)
  app.component(JtIconFilter.name!, JtIconFilter)
  app.component(JtIconFilter2.name!, JtIconFilter2)
  app.component(JtIconFinished.name!, JtIconFinished)
  app.component(JtIconFirstAidKit.name!, JtIconFirstAidKit)
  app.component(JtIconFlag.name!, JtIconFlag)
  app.component(JtIconFlipH.name!, JtIconFlipH)
  app.component(JtIconFlipV.name!, JtIconFlipV)
  app.component(JtIconFold.name!, JtIconFold)
  app.component(JtIconFolder.name!, JtIconFolder)
  app.component(JtIconFolderAdd.name!, JtIconFolderAdd)
  app.component(JtIconFolderChecked.name!, JtIconFolderChecked)
  app.component(JtIconFolderDelete.name!, JtIconFolderDelete)
  app.component(JtIconFolderOpened.name!, JtIconFolderOpened)
  app.component(JtIconFolderRemove.name!, JtIconFolderRemove)
  app.component(JtIconFood.name!, JtIconFood)
  app.component(JtIconFootball.name!, JtIconFootball)
  app.component(JtIconForkSpoon.name!, JtIconForkSpoon)
  app.component(JtIconFries.name!, JtIconFries)
  app.component(JtIconFullscreen.name!, JtIconFullscreen)
  app.component(JtIconFullScreen2.name!, JtIconFullScreen2)
  app.component(JtIconFullscreenExit.name!, JtIconFullscreenExit)
  app.component(JtIconGoblet.name!, JtIconGoblet)
  app.component(JtIconGobletFull.name!, JtIconGobletFull)
  app.component(JtIconGobletSquare.name!, JtIconGobletSquare)
  app.component(JtIconGobletSquareFull.name!, JtIconGobletSquareFull)
  app.component(JtIconGoods.name!, JtIconGoods)
  app.component(JtIconGoodsFilled.name!, JtIconGoodsFilled)
  app.component(JtIconGrape.name!, JtIconGrape)
  app.component(JtIconGrid.name!, JtIconGrid)
  app.component(JtIconGuide.name!, JtIconGuide)
  app.component(JtIconHeadset.name!, JtIconHeadset)
  app.component(JtIconHelp.name!, JtIconHelp)
  app.component(JtIconHelp2.name!, JtIconHelp2)
  app.component(JtIconHelpFilled.name!, JtIconHelpFilled)
  app.component(JtIconHide.name!, JtIconHide)
  app.component(JtIconHide2.name!, JtIconHide2)
  app.component(JtIconHistogram.name!, JtIconHistogram)
  app.component(JtIconHomeFilled.name!, JtIconHomeFilled)
  app.component(JtIconHotWater.name!, JtIconHotWater)
  app.component(JtIconHouse.name!, JtIconHouse)
  app.component(JtIconIceCream.name!, JtIconIceCream)
  app.component(JtIconIceCreamRound.name!, JtIconIceCreamRound)
  app.component(JtIconIceCreamSquare.name!, JtIconIceCreamSquare)
  app.component(JtIconIceDrink.name!, JtIconIceDrink)
  app.component(JtIconIceTea.name!, JtIconIceTea)
  app.component(JtIconImg.name!, JtIconImg)
  app.component(JtIconInfoFilled.name!, JtIconInfoFilled)
  app.component(JtIconInteract.name!, JtIconInteract)
  app.component(JtIconInternational.name!, JtIconInternational)
  app.component(JtIconIphone.name!, JtIconIphone)
  app.component(JtIconKey.name!, JtIconKey)
  app.component(JtIconKey2.name!, JtIconKey2)
  app.component(JtIconKeyboard.name!, JtIconKeyboard)
  app.component(JtIconKnifeFork.name!, JtIconKnifeFork)
  app.component(JtIconLayer.name!, JtIconLayer)
  app.component(JtIconLayoutColumn.name!, JtIconLayoutColumn)
  app.component(JtIconLayoutRow.name!, JtIconLayoutRow)
  app.component(JtIconLightning.name!, JtIconLightning)
  app.component(JtIconLineHide.name!, JtIconLineHide)
  app.component(JtIconLineShow.name!, JtIconLineShow)
  app.component(JtIconLink.name!, JtIconLink)
  app.component(JtIconLink2.name!, JtIconLink2)
  app.component(JtIconList.name!, JtIconList)
  app.component(JtIconLoading.name!, JtIconLoading)
  app.component(JtIconLocation.name!, JtIconLocation)
  app.component(JtIconLocationFilled.name!, JtIconLocationFilled)
  app.component(JtIconLocationInformation.name!, JtIconLocationInformation)
  app.component(JtIconLock.name!, JtIconLock)
  app.component(JtIconLock2.name!, JtIconLock2)
  app.component(JtIconLogout.name!, JtIconLogout)
  app.component(JtIconLollipop.name!, JtIconLollipop)
  app.component(JtIconMagic.name!, JtIconMagic)
  app.component(JtIconMagicStick.name!, JtIconMagicStick)
  app.component(JtIconMagnet.name!, JtIconMagnet)
  app.component(JtIconMale.name!, JtIconMale)
  app.component(JtIconManagement.name!, JtIconManagement)
  app.component(JtIconMap.name!, JtIconMap)
  app.component(JtIconMapLocation.name!, JtIconMapLocation)
  app.component(JtIconMaterial.name!, JtIconMaterial)
  app.component(JtIconMedal.name!, JtIconMedal)
  app.component(JtIconMedia.name!, JtIconMedia)
  app.component(JtIconMenu.name!, JtIconMenu)
  app.component(JtIconMessage.name!, JtIconMessage)
  app.component(JtIconMessageBox.name!, JtIconMessageBox)
  app.component(JtIconMic.name!, JtIconMic)
  app.component(JtIconMicrophone.name!, JtIconMicrophone)
  app.component(JtIconMilkTea.name!, JtIconMilkTea)
  app.component(JtIconMinus.name!, JtIconMinus)
  app.component(JtIconMobile.name!, JtIconMobile)
  app.component(JtIconMoney.name!, JtIconMoney)
  app.component(JtIconMonitor.name!, JtIconMonitor)
  app.component(JtIconMoon.name!, JtIconMoon)
  app.component(JtIconMoonNight.name!, JtIconMoonNight)
  app.component(JtIconMore.name!, JtIconMore)
  app.component(JtIconMoreFilled.name!, JtIconMoreFilled)
  app.component(JtIconMostlyCloudy.name!, JtIconMostlyCloudy)
  app.component(JtIconMouse.name!, JtIconMouse)
  app.component(JtIconMove.name!, JtIconMove)
  app.component(JtIconMoveBottom.name!, JtIconMoveBottom)
  app.component(JtIconMoveDown.name!, JtIconMoveDown)
  app.component(JtIconMoveTop.name!, JtIconMoveTop)
  app.component(JtIconMoveUp.name!, JtIconMoveUp)
  app.component(JtIconMug.name!, JtIconMug)
  app.component(JtIconMute.name!, JtIconMute)
  app.component(JtIconMuteNotification.name!, JtIconMuteNotification)
  app.component(JtIconMyCom.name!, JtIconMyCom)
  app.component(JtIconMyData.name!, JtIconMyData)
  app.component(JtIconNodal.name!, JtIconNodal)
  app.component(JtIconNoSmoking.name!, JtIconNoSmoking)
  app.component(JtIconNotebook.name!, JtIconNotebook)
  app.component(JtIconNotification.name!, JtIconNotification)
  app.component(JtIconOdometer.name!, JtIconOdometer)
  app.component(JtIconOfficeBuilding.name!, JtIconOfficeBuilding)
  app.component(JtIconOpen.name!, JtIconOpen)
  app.component(JtIconOperation.name!, JtIconOperation)
  app.component(JtIconOpportunity.name!, JtIconOpportunity)
  app.component(JtIconOrange.name!, JtIconOrange)
  app.component(JtIconOther.name!, JtIconOther)
  app.component(JtIconPaperclip.name!, JtIconPaperclip)
  app.component(JtIconPartlyCloudy.name!, JtIconPartlyCloudy)
  app.component(JtIconPear.name!, JtIconPear)
  app.component(JtIconPhone.name!, JtIconPhone)
  app.component(JtIconPhoneFilled.name!, JtIconPhoneFilled)
  app.component(JtIconPicture.name!, JtIconPicture)
  app.component(JtIconPictureFilled.name!, JtIconPictureFilled)
  app.component(JtIconPictureRounded.name!, JtIconPictureRounded)
  app.component(JtIconPieChart.name!, JtIconPieChart)
  app.component(JtIconPlace.name!, JtIconPlace)
  app.component(JtIconPlatform.name!, JtIconPlatform)
  app.component(JtIconPlus.name!, JtIconPlus)
  app.component(JtIconPlus2.name!, JtIconPlus2)
  app.component(JtIconPointer.name!, JtIconPointer)
  app.component(JtIconPosition.name!, JtIconPosition)
  app.component(JtIconPostcard.name!, JtIconPostcard)
  app.component(JtIconPouring.name!, JtIconPouring)
  app.component(JtIconPresent.name!, JtIconPresent)
  app.component(JtIconPreview.name!, JtIconPreview)
  app.component(JtIconPriceTag.name!, JtIconPriceTag)
  app.component(JtIconPrinter.name!, JtIconPrinter)
  app.component(JtIconPromotion.name!, JtIconPromotion)
  app.component(JtIconQuestionFilled.name!, JtIconQuestionFilled)
  app.component(JtIconRank.name!, JtIconRank)
  app.component(JtIconReading.name!, JtIconReading)
  app.component(JtIconReadingLamp.name!, JtIconReadingLamp)
  app.component(JtIconRedo.name!, JtIconRedo)
  app.component(JtIconRefresh.name!, JtIconRefresh)
  app.component(JtIconRefresh2.name!, JtIconRefresh2)
  app.component(JtIconRefreshLeft.name!, JtIconRefreshLeft)
  app.component(JtIconRefreshRight.name!, JtIconRefreshRight)
  app.component(JtIconRefrigerator.name!, JtIconRefrigerator)
  app.component(JtIconRelation.name!, JtIconRelation)
  app.component(JtIconRelease.name!, JtIconRelease)
  app.component(JtIconRemove.name!, JtIconRemove)
  app.component(JtIconRemoveFilled.name!, JtIconRemoveFilled)
  app.component(JtIconRight.name!, JtIconRight)
  app.component(JtIconRpanel.name!, JtIconRpanel)
  app.component(JtIconScaleToOriginal.name!, JtIconScaleToOriginal)
  app.component(JtIconSchool.name!, JtIconSchool)
  app.component(JtIconScissor.name!, JtIconScissor)
  app.component(JtIconSearch.name!, JtIconSearch)
  app.component(JtIconSearch2.name!, JtIconSearch2)
  app.component(JtIconSelect.name!, JtIconSelect)
  app.component(JtIconSelectArrow.name!, JtIconSelectArrow)
  app.component(JtIconSell.name!, JtIconSell)
  app.component(JtIconSemiSelect.name!, JtIconSemiSelect)
  app.component(JtIconService.name!, JtIconService)
  app.component(JtIconSetting.name!, JtIconSetting)
  app.component(JtIconSetting2.name!, JtIconSetting2)
  app.component(JtIconSetUp.name!, JtIconSetUp)
  app.component(JtIconShapeArrow.name!, JtIconShapeArrow)
  app.component(JtIconShapeAuto.name!, JtIconShapeAuto)
  app.component(JtIconShapeCircle.name!, JtIconShapeCircle)
  app.component(JtIconShapeDiamond.name!, JtIconShapeDiamond)
  app.component(JtIconShapeEmptyHeart.name!, JtIconShapeEmptyHeart)
  app.component(JtIconShapeHeart.name!, JtIconShapeHeart)
  app.component(JtIconShapeHexagon.name!, JtIconShapeHexagon)
  app.component(JtIconShapeRect.name!, JtIconShapeRect)
  app.component(JtIconShapeRoundRect.name!, JtIconShapeRoundRect)
  app.component(JtIconShapeRoundSquare.name!, JtIconShapeRoundSquare)
  app.component(JtIconShapeSquare.name!, JtIconShapeSquare)
  app.component(JtIconShapeTriangle.name!, JtIconShapeTriangle)
  app.component(JtIconShare.name!, JtIconShare)
  app.component(JtIconShip.name!, JtIconShip)
  app.component(JtIconShop.name!, JtIconShop)
  app.component(JtIconShoppingBag.name!, JtIconShoppingBag)
  app.component(JtIconShoppingCart.name!, JtIconShoppingCart)
  app.component(JtIconShoppingCartFull.name!, JtIconShoppingCartFull)
  app.component(JtIconShow.name!, JtIconShow)
  app.component(JtIconSmoking.name!, JtIconSmoking)
  app.component(JtIconSnapshot.name!, JtIconSnapshot)
  app.component(JtIconSoccer.name!, JtIconSoccer)
  app.component(JtIconSoldOut.name!, JtIconSoldOut)
  app.component(JtIconSort.name!, JtIconSort)
  app.component(JtIconSortDown.name!, JtIconSortDown)
  app.component(JtIconSortUp.name!, JtIconSortUp)
  app.component(JtIconStamp.name!, JtIconStamp)
  app.component(JtIconStar.name!, JtIconStar)
  app.component(JtIconStarFilled.name!, JtIconStarFilled)
  app.component(JtIconStop.name!, JtIconStop)
  app.component(JtIconStopwatch.name!, JtIconStopwatch)
  app.component(JtIconSuccessFilled.name!, JtIconSuccessFilled)
  app.component(JtIconSugar.name!, JtIconSugar)
  app.component(JtIconSuitcase.name!, JtIconSuitcase)
  app.component(JtIconSunny.name!, JtIconSunny)
  app.component(JtIconSunrise.name!, JtIconSunrise)
  app.component(JtIconSunset.name!, JtIconSunset)
  app.component(JtIconSwitch.name!, JtIconSwitch)
  app.component(JtIconSwitchButton.name!, JtIconSwitchButton)
  app.component(JtIconTable.name!, JtIconTable)
  app.component(JtIconTakeawayBox.name!, JtIconTakeawayBox)
  app.component(JtIconTicket.name!, JtIconTicket)
  app.component(JtIconTickets.name!, JtIconTickets)
  app.component(JtIconTimer.name!, JtIconTimer)
  app.component(JtIconTitle.name!, JtIconTitle)
  app.component(JtIconToiletPaper.name!, JtIconToiletPaper)
  app.component(JtIconToolbox.name!, JtIconToolbox)
  app.component(JtIconTools.name!, JtIconTools)
  app.component(JtIconTop.name!, JtIconTop)
  app.component(JtIconTopLeft.name!, JtIconTopLeft)
  app.component(JtIconTopRight.name!, JtIconTopRight)
  app.component(JtIconTrendCharts.name!, JtIconTrendCharts)
  app.component(JtIconTrophy.name!, JtIconTrophy)
  app.component(JtIconTurnOff.name!, JtIconTurnOff)
  app.component(JtIconTutorial.name!, JtIconTutorial)
  app.component(JtIconUmbrella.name!, JtIconUmbrella)
  app.component(JtIconUndo.name!, JtIconUndo)
  app.component(JtIconUnlock.name!, JtIconUnlock)
  app.component(JtIconUnlock2.name!, JtIconUnlock2)
  app.component(JtIconUpload.name!, JtIconUpload)
  app.component(JtIconUploadFilled.name!, JtIconUploadFilled)
  app.component(JtIconUser.name!, JtIconUser)
  app.component(JtIconUser2.name!, JtIconUser2)
  app.component(JtIconUserFilled.name!, JtIconUserFilled)
  app.component(JtIconVan.name!, JtIconVan)
  app.component(JtIconVideoCamera.name!, JtIconVideoCamera)
  app.component(JtIconVideoCameraFilled.name!, JtIconVideoCameraFilled)
  app.component(JtIconVideoPause.name!, JtIconVideoPause)
  app.component(JtIconVideoPlay.name!, JtIconVideoPlay)
  app.component(JtIconView.name!, JtIconView)
  app.component(JtIconViewGrid.name!, JtIconViewGrid)
  app.component(JtIconViewList.name!, JtIconViewList)
  app.component(JtIconWallet.name!, JtIconWallet)
  app.component(JtIconWalletFilled.name!, JtIconWalletFilled)
  app.component(JtIconWarning.name!, JtIconWarning)
  app.component(JtIconWarning2.name!, JtIconWarning2)
  app.component(JtIconWarningFilled.name!, JtIconWarningFilled)
  app.component(JtIconWatch.name!, JtIconWatch)
  app.component(JtIconWatermelon.name!, JtIconWatermelon)
  app.component(JtIconWindPower.name!, JtIconWindPower)
  app.component(JtIconWorkspace.name!, JtIconWorkspace)
  app.component(JtIconZoomIn.name!, JtIconZoomIn)
  app.component(JtIconZoomOut.name!, JtIconZoomOut)
}

export default { install }
export {
  JtIconAdaptAuto,
  JtIconAdaptHeight,
  JtIconAdaptWidth,
  JtIconAddLocation,
  JtIconAim,
  JtIconAlarmClock,
  JtIconApple,
  JtIconArrowDown,
  JtIconArrowDown2,
  JtIconArrowDownBold,
  JtIconArrowLeft,
  JtIconArrowLeft2,
  JtIconArrowLeftBold,
  JtIconArrowRight,
  JtIconArrowRight2,
  JtIconArrowRightBold,
  JtIconArrowUp,
  JtIconArrowUp2,
  JtIconArrowUpBold,
  JtIconAvatar,
  JtIconBack,
  JtIconBack2,
  JtIconBaseball,
  JtIconBasketball,
  JtIconBell,
  JtIconBellFilled,
  JtIconBicycle,
  JtIconBottom,
  JtIconBottomLeft,
  JtIconBottomRight,
  JtIconBowl,
  JtIconBox,
  JtIconBox2,
  JtIconBriefcase,
  JtIconBrush,
  JtIconBrushFilled,
  JtIconBurger,
  JtIconCalendar,
  JtIconCamera,
  JtIconCameraFilled,
  JtIconCaretBottom,
  JtIconCaretLeft,
  JtIconCaretRight,
  JtIconCaretTop,
  JtIconCellphone,
  JtIconChart,
  JtIconChartBar,
  JtIconChartLine,
  JtIconChartPie,
  JtIconChatDotRound,
  JtIconChatDotSquare,
  JtIconChatLineRound,
  JtIconChatLineSquare,
  JtIconChatRound,
  JtIconChatSquare,
  JtIconCheck,
  JtIconChecked,
  JtIconCherry,
  JtIconChicken,
  JtIconCircleCheck,
  JtIconCircleCheckFilled,
  JtIconCircleClose,
  JtIconCircleCloseFilled,
  JtIconCirclePlus,
  JtIconCirclePlusFilled,
  JtIconClock,
  JtIconClose,
  JtIconClose2,
  JtIconCloseBold,
  JtIconCloud,
  JtIconCloudy,
  JtIconCoffee,
  JtIconCoffeeCup,
  JtIconCoin,
  JtIconColdDrink,
  JtIconCollection,
  JtIconCollectionTag,
  JtIconComInfo,
  JtIconComment,
  JtIconCompass,
  JtIconComplete,
  JtIconConnection,
  JtIconCoordinate,
  JtIconCopy,
  JtIconCopyDocument,
  JtIconCpu,
  JtIconCreditCard,
  JtIconCrop,
  JtIconDarrowLeft,
  JtIconDarrowRight,
  JtIconDataAnalysis,
  JtIconDataBoard,
  JtIconDataLine,
  JtIconDcaret,
  JtIconDelete,
  JtIconDelete2,
  JtIconDeleteFilled,
  JtIconDeleteLocation,
  JtIconDessert,
  JtIconDiscount,
  JtIconDish,
  JtIconDishDot,
  JtIconDocument,
  JtIconDocument2,
  JtIconDocumentAdd,
  JtIconDocumentChecked,
  JtIconDocumentCopy,
  JtIconDocumentDelete,
  JtIconDocumentRemove,
  JtIconDownload,
  JtIconDrag,
  JtIconDrizzling,
  JtIconEdit,
  JtIconEdit2,
  JtIconEditorCanvas,
  JtIconEditPen,
  JtIconExpand,
  JtIconFailed,
  JtIconFavorite,
  JtIconFemale,
  JtIconFiles,
  JtIconFilm,
  JtIconFilter,
  JtIconFilter2,
  JtIconFinished,
  JtIconFirstAidKit,
  JtIconFlag,
  JtIconFlipH,
  JtIconFlipV,
  JtIconFold,
  JtIconFolder,
  JtIconFolderAdd,
  JtIconFolderChecked,
  JtIconFolderDelete,
  JtIconFolderOpened,
  JtIconFolderRemove,
  JtIconFood,
  JtIconFootball,
  JtIconForkSpoon,
  JtIconFries,
  JtIconFullscreen,
  JtIconFullScreen2,
  JtIconFullscreenExit,
  JtIconGoblet,
  JtIconGobletFull,
  JtIconGobletSquare,
  JtIconGobletSquareFull,
  JtIconGoods,
  JtIconGoodsFilled,
  JtIconGrape,
  JtIconGrid,
  JtIconGuide,
  JtIconHeadset,
  JtIconHelp,
  JtIconHelp2,
  JtIconHelpFilled,
  JtIconHide,
  JtIconHide2,
  JtIconHistogram,
  JtIconHomeFilled,
  JtIconHotWater,
  JtIconHouse,
  JtIconIceCream,
  JtIconIceCreamRound,
  JtIconIceCreamSquare,
  JtIconIceDrink,
  JtIconIceTea,
  JtIconImg,
  JtIconInfoFilled,
  JtIconInteract,
  JtIconInternational,
  JtIconIphone,
  JtIconKey,
  JtIconKey2,
  JtIconKeyboard,
  JtIconKnifeFork,
  JtIconLayer,
  JtIconLayoutColumn,
  JtIconLayoutRow,
  JtIconLightning,
  JtIconLineHide,
  JtIconLineShow,
  JtIconLink,
  JtIconLink2,
  JtIconList,
  JtIconLoading,
  JtIconLocation,
  JtIconLocationFilled,
  JtIconLocationInformation,
  JtIconLock,
  JtIconLock2,
  JtIconLogout,
  JtIconLollipop,
  JtIconMagic,
  JtIconMagicStick,
  JtIconMagnet,
  JtIconMale,
  JtIconManagement,
  JtIconMap,
  JtIconMapLocation,
  JtIconMaterial,
  JtIconMedal,
  JtIconMedia,
  JtIconMenu,
  JtIconMessage,
  JtIconMessageBox,
  JtIconMic,
  JtIconMicrophone,
  JtIconMilkTea,
  JtIconMinus,
  JtIconMobile,
  JtIconMoney,
  JtIconMonitor,
  JtIconMoon,
  JtIconMoonNight,
  JtIconMore,
  JtIconMoreFilled,
  JtIconMostlyCloudy,
  JtIconMouse,
  JtIconMove,
  JtIconMoveBottom,
  JtIconMoveDown,
  JtIconMoveTop,
  JtIconMoveUp,
  JtIconMug,
  JtIconMute,
  JtIconMuteNotification,
  JtIconMyCom,
  JtIconMyData,
  JtIconNodal,
  JtIconNoSmoking,
  JtIconNotebook,
  JtIconNotification,
  JtIconOdometer,
  JtIconOfficeBuilding,
  JtIconOpen,
  JtIconOperation,
  JtIconOpportunity,
  JtIconOrange,
  JtIconOther,
  JtIconPaperclip,
  JtIconPartlyCloudy,
  JtIconPear,
  JtIconPhone,
  JtIconPhoneFilled,
  JtIconPicture,
  JtIconPictureFilled,
  JtIconPictureRounded,
  JtIconPieChart,
  JtIconPlace,
  JtIconPlatform,
  JtIconPlus,
  JtIconPlus2,
  JtIconPointer,
  JtIconPosition,
  JtIconPostcard,
  JtIconPouring,
  JtIconPresent,
  JtIconPreview,
  JtIconPriceTag,
  JtIconPrinter,
  JtIconPromotion,
  JtIconQuestionFilled,
  JtIconRank,
  JtIconReading,
  JtIconReadingLamp,
  JtIconRedo,
  JtIconRefresh,
  JtIconRefresh2,
  JtIconRefreshLeft,
  JtIconRefreshRight,
  JtIconRefrigerator,
  JtIconRelation,
  JtIconRelease,
  JtIconRemove,
  JtIconRemoveFilled,
  JtIconRight,
  JtIconRpanel,
  JtIconScaleToOriginal,
  JtIconSchool,
  JtIconScissor,
  JtIconSearch,
  JtIconSearch2,
  JtIconSelect,
  JtIconSelectArrow,
  JtIconSell,
  JtIconSemiSelect,
  JtIconService,
  JtIconSetting,
  JtIconSetting2,
  JtIconSetUp,
  JtIconShapeArrow,
  JtIconShapeAuto,
  JtIconShapeCircle,
  JtIconShapeDiamond,
  JtIconShapeEmptyHeart,
  JtIconShapeHeart,
  JtIconShapeHexagon,
  JtIconShapeRect,
  JtIconShapeRoundRect,
  JtIconShapeRoundSquare,
  JtIconShapeSquare,
  JtIconShapeTriangle,
  JtIconShare,
  JtIconShip,
  JtIconShop,
  JtIconShoppingBag,
  JtIconShoppingCart,
  JtIconShoppingCartFull,
  JtIconShow,
  JtIconSmoking,
  JtIconSnapshot,
  JtIconSoccer,
  JtIconSoldOut,
  JtIconSort,
  JtIconSortDown,
  JtIconSortUp,
  JtIconStamp,
  JtIconStar,
  JtIconStarFilled,
  JtIconStop,
  JtIconStopwatch,
  JtIconSuccessFilled,
  JtIconSugar,
  JtIconSuitcase,
  JtIconSunny,
  JtIconSunrise,
  JtIconSunset,
  JtIconSwitch,
  JtIconSwitchButton,
  JtIconTable,
  JtIconTakeawayBox,
  JtIconTicket,
  JtIconTickets,
  JtIconTimer,
  JtIconTitle,
  JtIconToiletPaper,
  JtIconToolbox,
  JtIconTools,
  JtIconTop,
  JtIconTopLeft,
  JtIconTopRight,
  JtIconTrendCharts,
  JtIconTrophy,
  JtIconTurnOff,
  JtIconTutorial,
  JtIconUmbrella,
  JtIconUndo,
  JtIconUnlock,
  JtIconUnlock2,
  JtIconUpload,
  JtIconUploadFilled,
  JtIconUser,
  JtIconUser2,
  JtIconUserFilled,
  JtIconVan,
  JtIconVideoCamera,
  JtIconVideoCameraFilled,
  JtIconVideoPause,
  JtIconVideoPlay,
  JtIconView,
  JtIconViewGrid,
  JtIconViewList,
  JtIconWallet,
  JtIconWalletFilled,
  JtIconWarning,
  JtIconWarning2,
  JtIconWarningFilled,
  JtIconWatch,
  JtIconWatermelon,
  JtIconWindPower,
  JtIconWorkspace,
  JtIconZoomIn,
  JtIconZoomOut,
}